import { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const formatDetail = (d) => {
  if (!d) return "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return d.msg || String(d);
};

export default function AdminLogin({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      onLogin(data.access_token);
    } catch (err) {
      setError(formatDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  const inputCls = "w-full rounded-xl bg-white border border-[#E3E3F0] px-4 py-3.5 text-[#0F0F1A] placeholder-[#9A97B5] focus:outline-none focus:border-[#1B2FD8] transition-colors";

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <form data-testid="admin-login-form" onSubmit={submit} className="w-full max-w-md bg-white border border-[#E3E3F0] rounded-3xl p-8 sm:p-10 shadow-xl shadow-[#0B0B12]/5">
        <Link to="/" className="flex items-center gap-2.5 font-display font-extrabold text-xl tracking-tight text-[#0B0B12]">
          <img src="/images/logo.png" alt="HERcules Health logo" className="h-10 w-auto" />
          <span>HER<span className="text-[#1B2FD8]">cules</span> Health</span>
        </Link>
        <p className="mt-6 text-xs font-semibold uppercase tracking-[0.25em] text-[#1B2FD8]">Private</p>
        <h1 className="font-display font-extrabold text-3xl text-[#0B0B12] mt-2">Leads Dashboard</h1>
        <div className="mt-8 space-y-4">
          <div>
            <label className="block text-xs font-semibold uppercase tracking-[0.15em] mb-2 text-[#4A4A66]">Email</label>
            <input data-testid="admin-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com" className={inputCls} />
          </div>
          <div>
            <label className="block text-xs font-semibold uppercase tracking-[0.15em] mb-2 text-[#4A4A66]">Password</label>
            <input data-testid="admin-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className={inputCls} />
          </div>
        </div>
        {error && <p data-testid="admin-login-error" className="mt-4 text-sm font-semibold text-[#1B2FD8]">{error}</p>}
        <button data-testid="admin-login-submit" type="submit" disabled={busy} className="mt-6 w-full rounded-full bg-[#0B0B12] text-[#FFFFFF] py-4 font-display font-extrabold tracking-wide hover:bg-[#1B2FD8] disabled:opacity-60 transition-colors duration-300">
          {busy ? "SIGNING IN…" : "SIGN IN"}
        </button>
      </form>
    </div>
  );
}
